var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.8244 8.06311H9.17675C8.80979 8.09539 8.46827 8.26398 8.21947 8.53563C7.97066 8.80728 7.83261 9.16228 7.83261 9.53066C7.83261 9.89903 7.97066 10.254 8.21947 10.5257C8.46827 10.7973 8.80979 10.9659 9.17675 10.9982H14.5313V22.6559C14.5636 23.0228 14.7322 23.3644 15.0038 23.6132C15.2755 23.862 15.6305 24 15.9989 24C16.3673 24 16.7223 23.862 16.9939 23.6132C17.2656 23.3644 17.4341 23.0228 17.4664 22.6559V10.9982H22.8232C23.1902 10.9659 23.5318 10.7973 23.7806 10.5257C24.0294 10.254 24.1674 9.89903 24.1674 9.53066C24.1674 9.16228 24.0294 8.80728 23.7806 8.53563C23.5318 8.26398 23.1902 8.09539 22.8232 8.06311H22.8244Z"
  })));
};
export default SvgText;